// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/.pnpm/css-loader@3.6.0_webpack@4.47.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".multifactor-secret__show-manual .multifactor-secret__qr{opacity:0}.multifactor-secret__show-manual .multifactor-secret__manual{opacity:1}.multifactor-secret__qr{opacity:1;transition:opacity .25s}.multifactor-secret__code{position:relative}.multifactor-secret__manual{cursor:text;opacity:0;position:absolute;top:50%;transform:translateY(-50%);width:100%}.multifactor-secret__show{display:block;text-align:center}", ""]);
// Exports
module.exports = exports;
